import { render } from "./FPluginHome.vue?vue&type=template&id=4e1973e8&scoped=true"
import script from "./FPluginHome.vue?vue&type=script&lang=js"
export * from "./FPluginHome.vue?vue&type=script&lang=js"

import "./FPluginHome.vue?vue&type=style&index=0&id=4e1973e8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1973e8"]])

export default __exports__